import { z } from 'zod';
import { CrewIncentiveTypeEnum } from '../../../enums/crew.js';
import { CurrencyCode } from '../../../enums/currency.js';
import { enumToZodLiteralUnion, helperSchema } from '../../../zodExtensions.js';
import { variantExchangeLineItem } from '../../schema/claimLineItem.js';
// TODO: placeholder for pending
export const shopNowIdQueryParam = 'corsoShopNowId';
const totalSchema = z.object({
    amount: z.number(),
    currencyCode: enumToZodLiteralUnion(CurrencyCode),
});
// TODO: consolidate this and resolve typing issues with including Pegasus in broader API types
export const shopNowEvent = z.object({
    startShoppingUrl: z.string(),
    shopNowHeadline: helperSchema.nonEmptyString,
    shopNowDescription: helperSchema.nonEmptyString,
    shopNowIncentive: z
        .object({
        amount: helperSchema.nonNegativeNumber,
        type: enumToZodLiteralUnion(CrewIncentiveTypeEnum),
    })
        .optional(),
});
export const shopNowSession = z.object({
    id: z.string(),
    returnToCustomerAppUrl: z.string(),
    startShoppingIdUrl: z.string(),
    cancelShoppingIdUrl: z.string(),
    lineItems: z.array(variantExchangeLineItem),
    // the sum of any line_items scheduled to be gift_card or refund + incentive
    returnCreditTotal: totalSchema,
});
const baseCustomerAppHostConfig = z.object({
    orderIdFromPlatform: z.string(),
});
export const shopNowSessionCreate = shopNowSession
    .pick({
    // configured by the underlying pegasus rule
    returnCreditTotal: true,
})
    .extend({
    orderIdFromPlatform: z.string(),
    customerAppHostConfig: z.discriminatedUnion('type', [
        z
            .object({
            type: z.literal('standalone'),
            slug: z.string(),
        })
            .merge(baseCustomerAppHostConfig),
        z
            .object({
            type: z.literal('embedded'),
            parentHostUrl: z.string().url(),
        })
            .merge(baseCustomerAppHostConfig),
    ]),
    shopNowEvent,
});
export const shopNowSessionUpdate = shopNowSession.pick({
    lineItems: true,
});
//# sourceMappingURL=shopNow.js.map